export default ({ theme }) => `
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;

    @media(min-width: 768px) {
      h2 {
        font-size: 38px;
      }
    }

    .horizontal-rule {
      width: 100%;
      background-color: ${theme.accentColor};
      height: 0.5px;
      border: none;
      margin: 20px 0;
    }

  
  `;
